import type { JsonPatch } from "../../types/ai.js";

export function DiffViewer({ patch }: { patch: JsonPatch[] }) {
  if (patch.length === 0) {
    return <div style={{ color: "#94a3b8", fontSize: 12 }}>変更はありません。</div>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {patch.map((op, index) => {
        const tone = op.op === "add" ? "#16a34a" : op.op === "remove" ? "#dc2626" : "#d97706";
        const prefix = op.op === "add" ? "+" : op.op === "remove" ? "-" : "~";
        const value = "value" in op ? JSON.stringify(op.value).slice(0, 90) : "";
        return (
          <div key={`${op.op}-${op.path}-${index}`} style={{ fontFamily: "Consolas, monospace", fontSize: 12, lineHeight: 1.5 }}>
            <span style={{ color: tone, fontWeight: 800 }}>{prefix}</span>{" "}
            <span style={{ color: "#64748b" }}>{op.path}</span>
            {value && <span style={{ color: "#0f172a" }}> = {value}</span>}
          </div>
        );
      })}
    </div>
  );
}
